<template>
  <div class="auth-page">

    <div class="auth-overlay"></div>

    <div class="auth-container">

      <div class="auth-brand">
        📚 BookStore
      </div>

      <div class="auth-card">

        <div class="text-center mb-4">

          <div class="auth-icon">
            📚
          </div>

          <h2 class="fw-bold">
            {{ isLogin
              ? 'Welcome Back'
              : 'Create Your Account'
            }}
          </h2>

          <p class="text-muted">
            {{
              isLogin
                ? 'Login to continue to your bookstore'
                : 'Join our bookstore community'
            }}
          </p>

        </div>

        <!-- Login -->
        <form
          v-if="isLogin"
          @submit.prevent="login"
        >

          <div class="mb-3">

            <label class="form-label">
              Email
            </label>

            <input
              v-model.trim="loginForm.email"
              type="email"
              class="form-control form-control-lg"
              placeholder="Enter your email"
              required
            >

          </div>

          <div class="mb-3">

            <label class="form-label">
              Password
            </label>

            <input
              v-model="loginForm.password"
              type="password"
              class="form-control form-control-lg"
              placeholder="Enter your password"
              required
            >

          </div>

          <div
            v-if="error"
            class="alert alert-danger"
          >
            {{ error }}
          </div>

          <button
            type="submit"
            class="btn btn-primary btn-lg w-100"
          >
            Login
          </button>

        </form>

        <!-- Register -->
        <form
          v-else
          @submit.prevent="register"
        >

          <div class="mb-3">

            <label class="form-label">
              Full Name
            </label>

            <input
              v-model.trim="registerForm.name"
              type="text"
              class="form-control form-control-lg"
              placeholder="Enter your name"
              required
            >

          </div>

          <div class="mb-3">

            <label class="form-label">
              Email
            </label>

            <input
              v-model.trim="registerForm.email"
              type="email"
              class="form-control form-control-lg"
              placeholder="Enter your email"
              required
            >

          </div>

          <div class="mb-3">

            <label class="form-label">
              Password
            </label>

            <input
              v-model="registerForm.password"
              type="password"
              class="form-control form-control-lg"
              placeholder="Create a password"
              minlength="6"
              required
            >

          </div>

          <!-- Role -->
          <div class="mb-4">

            <label class="form-label fw-semibold">
              I want to join as
            </label>

            <div class="row g-3">

              <div class="col-6">

                <button
                  type="button"
                  class="role-card w-100"
                  :class="{
                    selected:
                      registerForm.role ===
                      'buyer'
                  }"
                  @click="
                    registerForm.role =
                      'buyer'
                  "
                >
                  <span class="role-icon">
                    🛍️
                  </span>

                  <strong>
                    Buyer
                  </strong>

                  <small>
                    Browse & shop
                  </small>
                </button>

              </div>

              <div class="col-6">

                <button
                  type="button"
                  class="role-card w-100"
                  :class="{
                    selected:
                      registerForm.role ===
                      'seller'
                  }"
                  @click="
                    registerForm.role =
                      'seller'
                  "
                >
                  <span class="role-icon">
                    🏪
                  </span>

                  <strong>
                    Seller
                  </strong>

                  <small>
                    Manage books
                  </small>
                </button>

              </div>

            </div>

          </div>

          <div
            v-if="error"
            class="alert alert-danger"
          >
            {{ error }}
          </div>

          <button
            type="submit"
            class="btn btn-primary btn-lg w-100"
          >
            Create Account
          </button>

        </form>

        <div
          class="text-center mt-4"
        >

          <span class="text-muted">
            {{
              isLogin
                ? "Don't have an account?"
                : 'Already have an account?'
            }}
          </span>

          <button
            class="btn btn-link p-0 ms-1"
            @click="
              toggleMode
            "
          >
            {{
              isLogin
                ? 'Create Account'
                : 'Login'
            }}
          </button>

        </div>

      </div>

      <p class="auth-footer">
        BookStore Management System
      </p>

    </div>

  </div>
</template>

<script>
export default {
  name: 'Auth',

  data() {
    return {
      isLogin: true,

      error: '',

      loginForm: {
        email: '',
        password: ''
      },

      registerForm: {
        name: '',
        email: '',
        password: '',
        role: 'buyer'
      }
    }
  },

  methods: {
    toggleMode() {
      this.isLogin =
        !this.isLogin

      this.error = ''
    },

    async login() {
      this.error = ''

      const result =
        await this.$store.dispatch(
          'login',
          {
            email:
              this.loginForm.email,
            password:
              this.loginForm.password
          }
        )

      if (!result.success) {
        this.error =
          result.message

        return
      }

      this.redirectByRole()
    },

    async register() {
      this.error = ''

      const result =
        await this.$store.dispatch(
          'register',
          {
            name:
              this.registerForm.name,

            email:
              this.registerForm.email,

            password:
              this.registerForm.password,

            role:
              this.registerForm.role
          }
        )

      if (!result.success) {
        this.error =
          result.message

        return
      }

      this.redirectByRole()
    },

    redirectByRole() {
      const role =
        this.$store.getters.userRole

      if (role === 'seller') {
        this.$router.push(
          '/seller'
        )
      } else {
        this.$router.push(
          '/buyer'
        )
      }
    }
  }
}
</script>

<style scoped>
.auth-page {
  min-height: 100vh;

  background-image: url(
    "https://images.unsplash.com/photo-1524995997946-a1c2e315a42f?auto=format&fit=crop&w=2000&q=85"
  );

  background-size: cover;
  background-position: center;

  display: flex;
  align-items: center;
  justify-content: center;

  position: relative;

  padding: 30px 15px;
}

.auth-overlay {
  position: absolute;
  inset: 0;

  background:
    linear-gradient(
      135deg,
      rgba(21, 8, 93, 0.75),
      rgba(89, 15, 109, 0.6)
    );
}

.auth-container {
  width: 100%;
  max-width: 470px;

  position: relative;
  z-index: 2;
}

.auth-brand {
  color: white;

  text-align: center;

  font-size: 1.7rem;

  font-weight: 700;

  margin-bottom: 20px;
}

.auth-card {
  background: rgba(
    255,
    255,
    255,
    0.97
  );

  border-radius: 24px;

  padding: 35px;

  box-shadow:
    0 25px 70px
    rgba(0, 0, 0, 0.25);
}

.auth-icon {
  width: 65px;
  height: 65px;

  margin: 0 auto 15px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 18px;

  background: #5a219bb6;

  font-size: 1.8rem;
}

/* =================================
   BUYER / SELLER ROLE CARDS
================================= */

.role-card {
  width: 100%;

  min-height: 160px;

  border: 2px solid #c4b5fd;

  background: #ffffff;

  border-radius: 16px;

  padding: 18px 12px;

  display: flex;

  flex-direction: column;

  align-items: center;

  justify-content: center;

  gap: 6px;

  cursor: pointer;

  transition:
    all 0.25s ease;

  color: #2e1065 !important;
}

.role-card:hover {
  border-color: #8b5cf6;

  background: #faf7ff;

  transform:
    translateY(-2px);

  box-shadow:
    0 8px 20px
    rgba(
      108,
      59,
      255,
      0.10
    );
}

/* Selected card */

.role-card.selected {
  border-color: #6c3bff;

  background:
    linear-gradient(
      135deg,
      #f1ecff,
      #faf7ff
    );

  box-shadow:
    0 8px 22px
    rgba(
      108,
      59,
      255,
      0.14
    );
}

/* Icon */

.role-icon {
  display: block;

  font-size: 2rem;

  line-height: 1;

  margin-bottom: 6px;
}

/* Buyer / Seller */

.role-card strong {
  display: block;

  color: #4c1d95 !important;

  font-size: 1rem;

  font-weight: 800;

  opacity: 1 !important;

  visibility: visible !important;
}

/* Description */

.role-card small {
  display: block;

  color: #6d5a85 !important;

  font-size: 0.82rem;

  font-weight: 500;

  opacity: 1 !important;

  visibility: visible !important;
}

/* Selected text */

.role-card.selected strong {
  color: #5b21b6 !important;
}

.role-card.selected small {
  color: #6d28d9 !important;
}

/* =================================
   DARK MODE
================================= */

:global(.dark-mode)
.role-card {
  background: #1e1730;

  border-color: #493866;

  color: #f5f3ff !important;
}

:global(.dark-mode)
.role-card:hover {
  background: #241a39;

  border-color: #8b5cf6;
}

:global(.dark-mode)
.role-card.selected {
  background:
    linear-gradient(
      135deg,
      #291d43,
      #211936
    );

  border-color: #8b5cf6;
}

:global(.dark-mode)
.role-card strong {
  color: #ddd0ff !important;
}

:global(.dark-mode)
.role-card small {
  color: #b9aecb !important;
}

:global(.dark-mode)
.role-card.selected strong {
  color: #c4b5fd !important;
}

:global(.dark-mode)
.role-card.selected small {
  color: #c4b5fd !important;
}
.auth-footer {
  text-align: center;

  margin-top: 20px;

  color: rgba(
    255,
    255,
    255,
    0.75
  );

  font-size: 0.85rem;
}

@media (max-width: 576px) {
  .auth-card {
    padding: 25px 20px;
  }
}
.auth-card h2 {
  color: #4c1d95;
  font-weight: 800;
}

.auth-card > .text-center p {
  color: #7c3aed;
  font-weight: 500;
}

.auth-card .form-label {
  color: #6d28d9;
  font-weight: 600;
}
</style>